import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {Router} from '@angular/router';
import {UserSession} from '../../../interfaces/loginInterface';

@Injectable()
export class AuthService {
  private userSessionKey = 'vendorClientUser_data';
  private userSubject: BehaviorSubject<UserSession | null>;
  public user$: Observable<UserSession | null>;

  constructor(private route:Router) {
    const userData = localStorage.getItem(this.userSessionKey);
    this.userSubject = new BehaviorSubject<UserSession | null>(
      userData ? JSON.parse(userData) : null
    );
    this.user$ = this.userSubject.asObservable();
  }

  saveCredentials(data: UserSession): void {
    localStorage.setItem(this.userSessionKey, JSON.stringify(data));
    this.userSubject.next(data);
  }

  getUserData(): UserSession | null {
    return this.userSubject.value;
  }

  logout(): void {
    localStorage.removeItem(this.userSessionKey);
    this.userSubject.next(null);
    this.route.navigate(['/login']);
  }

}
